import { render, staticRenderFns } from "./hoverOverlayLink.vue?vue&type=template&id=ff487122&"
import script from "./hoverOverlayLink.vue?vue&type=script&lang=js&"
export * from "./hoverOverlayLink.vue?vue&type=script&lang=js&"
import style0 from "./hoverOverlayLink.vue?vue&type=style&index=0&id=ff487122&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports